import { PaginatedData } from '../types'

export enum NotificationType {
  QuizCompletedBothSides = 'quiz_completed_both_sides',
  QuizCompletedFriend = 'quiz_completed_friend',
  QuizNewPublished = 'quiz_new_published',
  FriendRequestNew = 'friend_request_new',
  FriendRequestApproved = 'friend_request_approved',
  FriendRequestApprovedByMe = 'friend_request_approved_by_me',
}

export interface INotification {
  id: number
  userId: string
  otherUserId: string
  eventType: NotificationType
  updatedAt: string
  deletedAt: null | string
  createdAt: string
  quizId: number
  imageUrl: string
  description: string
  highlightedWords: string[]
  connectionId?: number
}

export type NotificationsResponse = PaginatedData<INotification>
